"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAV_APPS = exports.MOCK_SPEED_KMH = exports.MOCK_ROAD_FACTOR = exports.ROUTING_MODES = void 0;
exports.mockRouteOrder = mockRouteOrder;
exports.mockLegs = mockLegs;
exports.stopKey = stopKey;
exports.navigationLink = navigationLink;
// Route order (plan 4.4). The real order comes from VROOM + OSRM on the road network
// (ROUTING_MODE=osrm). For local testing without the map download, ROUTING_MODE=mock uses
// straight lines: nearest stop first, then 2-opt to remove crossings. Same input and output.
const consignee_1 = require("./consignee");
exports.ROUTING_MODES = ['mock', 'osrm'];
/** Straight lines are shorter than roads: Dubai streets add about a third. */
exports.MOCK_ROAD_FACTOR = 1.35;
/** Average driving speed in town for the mock estimate (km/h). */
exports.MOCK_SPEED_KMH = 28;
/** Visiting order (indexes into `stops`) from `start`, open route (the courier does not return). */
function mockRouteOrder(start, stops) {
    const n = stops.length;
    if (n <= 1)
        return stops.map((_, i) => i);
    const d = (a, b) => (0, consignee_1.distanceMetres)(a, b);
    // nearest neighbour
    const left = new Set(stops.map((_, i) => i));
    const order = [];
    let at = start;
    while (left.size) {
        let best = -1;
        let bestD = Infinity;
        for (const i of left) {
            const di = d(at, stops[i]);
            if (di < bestD)
                [best, bestD] = [i, di];
        }
        order.push(best);
        left.delete(best);
        at = stops[best];
    }
    // 2-opt on the open path start → order[0] → … → order[n-1]
    const pt = (k) => (k < 0 ? start : stops[order[k]]);
    let improved = true;
    for (let pass = 0; improved && pass < 50; pass += 1) {
        improved = false;
        for (let i = 0; i < n - 1; i += 1) {
            for (let k = i + 1; k < n; k += 1) {
                const before = d(pt(i - 1), pt(i)) + (k + 1 < n ? d(pt(k), pt(k + 1)) : 0);
                const after = d(pt(i - 1), pt(k)) + (k + 1 < n ? d(pt(i), pt(k + 1)) : 0);
                if (after + 0.5 < before) {
                    order.splice(i, k - i + 1, ...order.slice(i, k + 1).reverse());
                    improved = true;
                }
            }
        }
    }
    return order;
}
/** Road metres and driving seconds of each leg of the mock route (start → first stop, …). */
function mockLegs(start, ordered) {
    let at = start;
    return ordered.map((p) => {
        const metres = Math.round((0, consignee_1.distanceMetres)(at, p) * exports.MOCK_ROAD_FACTOR);
        at = p;
        return { metres, seconds: Math.round(metres / ((exports.MOCK_SPEED_KMH * 1000) / 3600)) };
    });
}
/** Parcels that share a customer and an address are one stop (delivered together, one 'Going there now'). */
function stopKey(s) {
    return s.consigneeId ? `${s.consigneeId}|${s.districtId ?? s.addressText ?? ''}` : s.id;
}
/** Navigation apps the courier can choose (plan step 7: 2GIS, Google Maps or Waze). */
exports.NAV_APPS = ['google', 'waze', '2gis'];
/** Link that opens turn-by-turn driving to the pin in the chosen app. */
function navigationLink(app, p) {
    const lat = p.latitude.toFixed(6);
    const lng = p.longitude.toFixed(6);
    if (app === 'waze')
        return `https://waze.com/ul?ll=${lat},${lng}&navigate=yes`;
    if (app === '2gis')
        return `https://2gis.ae/routeSearch/rsType/car/to/${lng},${lat}`;
    return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}&travelmode=driving`;
}
//# sourceMappingURL=routing.js.map